module.exports = __webpack_public_path__ + "static/story4-small-thumbnails-100x100-39a597db8ca1e0cae599218e243ce990.jpg";